import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useTranslation } from "@/context/TranslationContext";

const values = [
  {
    icon: "ri-shield-check-line",
    titleKey: "about.value1_title",
    descriptionKey: "about.value1_description",
    color: "text-electric-blue",
    border: "border-electric-blue/20",
    bg: "bg-electric-blue/5",
  },
  {
    icon: "ri-speed-line",
    titleKey: "about.value2_title",
    descriptionKey: "about.value2_description",
    color: "text-cyber-green",
    border: "border-cyber-green/20",
    bg: "bg-cyber-green/5",
  },
  {
    icon: "ri-global-line",
    titleKey: "about.value3_title",
    descriptionKey: "about.value3_description",
    color: "text-cyber-orange",
    border: "border-cyber-orange/20",
    bg: "bg-cyber-orange/5",
  },
  {
    icon: "ri-team-line",
    titleKey: "about.value4_title",
    descriptionKey: "about.value4_description",
    color: "text-electric-blue",
    border: "border-electric-blue/20",
    bg: "bg-electric-blue/5",
  },
  {
    icon: "ri-lightbulb-line",
    titleKey: "about.value5_title",
    descriptionKey: "about.value5_description",
    color: "text-cyber-green",
    border: "border-cyber-green/20",
    bg: "bg-cyber-green/5",
  },
  {
    icon: "ri-lock-line",
    titleKey: "about.value6_title",
    descriptionKey: "about.value6_description",
    color: "text-cyber-red",
    border: "border-cyber-red/20",
    bg: "bg-cyber-red/5",
  },
];

const team = [
  {
    name: "Tama Eugene Legrand",
    role: "Founder, CTO & CEO",
    bioKey: "about.team_bio_tama",
    avatar: "https://readdy.ai/api/search-image?query=professional%20African%20male%20tech%20CEO%20portrait%2C%20dark%20background%2C%20confident%20expression%2C%20business%20casual%20attire%2C%20studio%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team-ceo-001&orientation=squarish",
    socials: { linkedin: "#", twitter: "#" },
    tags: ["SaaS Architecture", "Product Strategy", "Fintech"],
  },
  {
    name: "Buh Fang Che Emmanuel",
    role: "Designer & Lead Marketing Manager",
    bioKey: "about.team_bio_buh",
    avatar: "https://readdy.ai/api/search-image?query=professional%20African%20male%20designer%20marketing%20manager%20portrait%2C%20dark%20background%2C%20confident%20expression%2C%20business%20casual%20attire%2C%20studio%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team-cto-001&orientation=squarish",
    socials: { linkedin: "#" },
    tags: ["Canva", "Bandicam", "Filmora"],
  },
  {
    name: "Muchi Pascal Remy Owona",
    role: "Lead Developer & Security Analyst",
    bioKey: "about.team_bio_muchi",
    avatar: "https://readdy.ai/api/search-image?query=professional%20African%20male%20software%20developer%20security%20analyst%20portrait%2C%20dark%20background%2C%20intelligent%20expression%2C%20casual%20tech%20attire%2C%20studio%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team-ai-001&orientation=squarish",
    socials: { linkedin: "#", github: "#" },
    tags: ["Full-Stack", "Automations", "Security"],
  },
  {
    name: "Djakoua Didier",
    role: "System Designer & Architect",
    bioKey: "about.team_bio_djakoua",
    avatar: "https://readdy.ai/api/search-image?query=professional%20African%20male%20system%20architect%20backend%20engineer%20portrait%2C%20dark%20background%2C%20focused%20expression%2C%20tech%20attire%2C%20studio%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team-design-001&orientation=squarish",
    socials: { linkedin: "#" },
    tags: ["Backend", "Design Systems", "DB Management"],
  },
  {
    name: "Tonguo De Fotso Georgeable",
    role: "Marketing Operator",
    bioKey: "about.team_bio_tonguoa",
    avatar: "https://readdy.ai/api/search-image?query=professional%20African%20male%20marketing%20operator%20portrait%2C%20dark%20background%2C%20professional%20expression%2C%20business%20casual%20attire%2C%20studio%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team-fintech-001&orientation=squarish",
    socials: { linkedin: "#" },
    tags: ["Digital Marketing", "Content Strategy", "Outreach"],
  },
  {
    name: "Tama Ulrich Evrard",
    role: "Co-Founder & COO",
    bioKey: "about.team_bio_tama_ulrich",
    avatar: "https://readdy.ai/api/search-image?query=professional%20African%20male%20COO%20co-founder%20portrait%2C%20dark%20background%2C%20warm%20confident%20expression%2C%20business%20casual%20attire%2C%20studio%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team-cs-001&orientation=squarish",
    socials: { linkedin: "#" },
    tags: ["Client Relations", "Project Management", "Strategy"],
  },
];

const stats = [
  { value: "10+", labelKey: "about.stat_projects_delivered", icon: "ri-rocket-line" },
  { value: "88%", labelKey: "about.stat_client_satisfaction", icon: "ri-heart-line" },
  { value: "10+", labelKey: "about.stat_team_members", icon: "ri-team-line" },
  { value: "03+", labelKey: "about.stat_countries_served", icon: "ri-global-line" },
  { value: "02", labelKey: "about.stat_years_experience", icon: "ri-calendar-line" },
];

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-deep-black font-inter">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-36 pb-24 px-4 md:px-12 lg:px-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20futuristic%20abstract%20technology%20background%20with%20glowing%20blue%20geometric%20shapes%2C%20digital%20art%2C%20deep%20space%20atmosphere%2C%20electric%20blue%20light%20patterns%2C%20cinematic%20dark%20sci-fi%2C%20no%20people&width=1920&height=700&seq=about-hero-bg-001&orientation=landscape"
            alt="About background"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-deep-black/60 via-deep-black/40 to-deep-black" />
          <div className="absolute inset-0 bg-circuit-pattern opacity-30" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-5 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("about.hero_badge")}
            </span>
            <h1 className="font-black text-white leading-tight mb-6" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(2.5rem, 5vw, 4.5rem)" }}>
              {t("about.hero_title")}<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric-blue to-cyber-blue">
                {t("about.hero_highlight")}
              </span>
            </h1>
            <p className="text-silver text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
              {t("about.hero_description")}
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {stats.map((stat) => (
              <div key={stat.labelKey} className="bg-dark-card border border-dark-border rounded-2xl p-4 text-center hover:border-electric-blue/20 transition-colors">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                  <i className={`${stat.icon} text-electric-blue text-lg`} />
                </div>
                <div className="text-xl font-black text-electric-blue mb-1" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                  {stat.value}
                </div>
                <div className="text-silver-dim text-xs leading-tight">{t(stat.labelKey)}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 px-4 md:px-12 lg:px-20 bg-dark-panel border-t border-dark-border">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-5 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("about.purpose_badge")}
            </span>
            <h2 className="font-black text-white mb-8" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(1.8rem, 3vw, 2.8rem)" }}>
              {t("about.purpose_title")}
            </h2>

            <div className="space-y-8">
              <div className="border-l-2 border-electric-blue pl-6">
                <h3 className="text-white font-bold text-lg mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                  {t("about.mission_title")}
                </h3>
                <p className="text-silver text-sm leading-relaxed">
                  {t("about.mission_description")}
                </p>
              </div>

              <div className="border-l-2 border-cyber-green pl-6">
                <h3 className="text-white font-bold text-lg mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                  {t("about.vision_title")}
                </h3>
                <p className="text-silver text-sm leading-relaxed">
                  {t("about.vision_description")}
                </p>
              </div>

              <div className="border-l-2 border-cyber-orange pl-6">
                <h3 className="text-white font-bold text-lg mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                  {t("about.approach_title")}
                </h3>
                <p className="text-silver text-sm leading-relaxed">
                  {t("about.approach_description")}
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-4 rounded-3xl bg-electric-blue/5 blur-2xl opacity-40" />
            <div className="relative rounded-2xl border border-dark-border overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=diverse%20African%20tech%20team%20working%20together%20in%20modern%20dark%20office%2C%20multiple%20monitors%20with%20code%20and%20dashboards%2C%20collaborative%20engineering%20environment%2C%20professional%20photography%2C%20cinematic%20lighting%2C%20dark%20background&width=700&height=500&seq=about-team-working-001&orientation=landscape"
                alt="Schemackozo team at work"
                className="w-full h-80 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-dark-card/50 to-transparent" />
            </div>
            <div className="absolute -bottom-5 -right-5 bg-dark-card border border-electric-blue/30 rounded-xl p-4 hidden lg:block">
              <div className="text-electric-blue text-xs font-semibold uppercase tracking-widest mb-1">{t("about.remote_first")}</div>
              <div className="text-white font-bold text-sm">{t("about.remote_countries")}</div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 px-4 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-4 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("about.values_badge")}
            </span>
            <h2 className="font-black text-white" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(1.8rem, 3vw, 2.8rem)" }}>
              {t("about.values_title")}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {values.map((v) => (
              <div
                key={v.titleKey}
                className={`group border ${v.border} ${v.bg} rounded-2xl p-6 hover:border-opacity-60 transition-all duration-300`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-dark-card border border-dark-border mb-5 ${v.color}`}>
                  <i className={`${v.icon} text-xl`} />
                </div>
                <h3 className="text-white font-bold text-base mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                  {t(v.titleKey)}
                </h3>
                <p className="text-silver text-sm leading-relaxed">{t(v.descriptionKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 px-4 md:px-12 lg:px-20 bg-dark-panel border-t border-dark-border">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-4 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("about.team_badge")}
            </span>
            <h2 className="font-black text-white mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(1.8rem, 3vw, 2.8rem)" }}>
              {t("about.team_title")}
            </h2>
            <p className="text-silver text-sm max-w-xl mx-auto">
              {t("about.team_description")}
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {team.map((member) => (
              <div
                key={member.name}
                className="group bg-dark-card border border-dark-border rounded-2xl overflow-hidden hover:border-electric-blue/20 transition-all duration-300"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={member.avatar}
                    alt={member.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-card via-transparent to-transparent" />
                </div>
                <div className="p-5">
                  <h3 className="text-white font-bold text-base mb-0.5" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                    {member.name}
                  </h3>
                  <p className="text-electric-blue text-xs font-semibold mb-3">{member.role}</p>
                  <p className="text-silver-dim text-xs leading-relaxed mb-4">{t(member.bioKey)}</p>
                  <div className="flex flex-wrap gap-1.5 mb-4">
                    {member.tags.map((tag) => (
                      <span key={tag} className="text-xs px-2 py-0.5 rounded bg-deep-black border border-dark-border text-silver-dim">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center gap-2">
                    {member.socials.linkedin && (
                      <a href={member.socials.linkedin} rel="nofollow noopener noreferrer" target="_blank" className="w-7 h-7 flex items-center justify-center rounded-full border border-dark-border text-silver-dim hover:text-electric-blue hover:border-electric-blue/40 transition-all cursor-pointer">
                        <i className="ri-linkedin-line text-xs" />
                      </a>
                    )}
                    {member.socials.twitter && (
                      <a href={member.socials.twitter} rel="nofollow noopener noreferrer" target="_blank" className="w-7 h-7 flex items-center justify-center rounded-full border border-dark-border text-silver-dim hover:text-electric-blue hover:border-electric-blue/40 transition-all cursor-pointer">
                        <i className="ri-twitter-x-line text-xs" />
                      </a>
                    )}
                    {member.socials.github && (
                      <a href={member.socials.github} rel="nofollow noopener noreferrer" target="_blank" className="w-7 h-7 flex items-center justify-center rounded-full border border-dark-border text-silver-dim hover:text-electric-blue hover:border-electric-blue/40 transition-all cursor-pointer">
                        <i className="ri-github-line text-xs" />
                      </a>
                    )}
                    {member.socials.dribbble && (
                      <a href={member.socials.dribbble} rel="nofollow noopener noreferrer" target="_blank" className="w-7 h-7 flex items-center justify-center rounded-full border border-dark-border text-silver-dim hover:text-electric-blue hover:border-electric-blue/40 transition-all cursor-pointer">
                        <i className="ri-dribbble-line text-xs" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

{/* Vision */}
      <section className="py-20 px-4 md:px-12 lg:px-20 bg-dark-panel border-t border-dark-border">
        <div className="w-full">
          <div className="text-center mb-14">
            <span className="inline-block text-electric-blue text-xs font-semibold uppercase tracking-[0.2em] mb-4 px-3 py-1.5 border border-electric-blue/25 rounded-full bg-electric-blue/5">
              {t("about.vision_section_badge")}
            </span>
            <h2 className="font-black text-white mb-4" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(1.8rem, 3vw, 2.8rem)" }}>
              {t("about.vision_section_title")}
            </h2>
          </div>
          <p className="text-silver text-sm md:text-base leading-relaxed px-4 md:px-8">
            {t("about.vision_section_description")}
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 px-4 md:px-12 lg:px-20 bg-dark-panel border-t border-dark-border">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-black text-white mb-5" style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
            {t("about.cta_title")}
          </h2>
          <p className="text-silver text-base mb-10 leading-relaxed">
            {t("about.cta_description")}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/pricing"
              className="flex items-center gap-2 bg-electric-blue text-deep-black font-bold px-8 py-4 rounded-full hover:shadow-glow-blue transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t("about.cta_primary")}
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/portfolio"
              className="flex items-center gap-2 border border-dark-border text-silver hover:border-electric-blue/30 hover:text-white px-8 py-4 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t("about.cta_secondary")}
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
